import request from '@/utils/request'

export function getDictSel (query) {
  return request({
    url: 'dict/notcheck/sel',
    method: 'get',
    params: query
  })
}

export function getDictSelArr (query) {
  return request({
    url: 'dict/notcheck/sel/arr',
    method: 'get',
    params: query
  })
}
